var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-label-box",style:({ backgroundColor: _vm.bgColor })},[_c('asc-label',{style:({ backgroundColor: _vm.bgColor, color: _vm.color }),attrs:{"size":"sm","value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }